import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SortType } from '../../../../common/enums/SortType';
import { formatDate } from '../../../../common/helpers/dateHelper';
import Highlighter from 'react-highlight-words';
import Icon from '../../../../components/Icon';
import UserLogo from '../../../../components/UserLogo';
import { Column } from '../../../../common/models/table/Column';
import { ISurvey } from '../../../../common/models/survey/ISurvey';
import Tooltip from '../../../../components/Tooltip';
import TextOverflowTooltip from '../../../../components/TextOverflowTooltip';
import EmptyFieldPlaceholder from '../../../../components/EmptyFieldPlaceholder';

const getOwnerIcon = (survey: ISurvey) => (
  survey.owner
    ? <UserLogo user={survey.owner} />
    : (
      <Tooltip content={<FormattedMessage id="KodiakHR" defaultMessage="KodiakHR" />}>
        <Icon icon="logo" />
      </Tooltip>
    )
);

export const getColumns = (search: string): Column[] => [
  {
    Header: () => <FormattedMessage id="surveyTable.lastUsed" defaultMessage="Last used" />,
    id: 'lastSendDate',
    accessor: 'lastSendDate',
    width: 120,
    Cell: ({ cell: { value } }) => (value ? formatDate(value) : <EmptyFieldPlaceholder />),
    sortType: SortType.Date
  },
  {
    Header: () => <FormattedMessage id="surveyTable.favorite" defaultMessage="Favorite" />,
    id: 'isFavorite',
    accessor: 'isFavorite',
    width: 90,
    sortType: SortType.Favorites,
    Cell: ({ cell: { value } }) => (
      <div className="table-center" style={{ maxWidth: 55 }}>
        <Tooltip content={<FormattedMessage id="iconButtonLable.favorite" defaultMessage="Favorite" />}>
          {value
            ? <Icon icon="activeStar" className="table-icon cursor-pointer" />
            : <Icon icon="inactiveStar" className="table-icon hover-icon-stroke cursor-pointer" />}
        </Tooltip>
      </div>
    )
  },
  {
    Header: () => <FormattedMessage id="surveyTable.surveyTitle" defaultMessage="Survey title" />,
    id: 'name',
    accessor: 'name',
    width: 700,
    Cell: ({ row: { original } }) => {
      const { name, description } = original as ISurvey;
      return (
        <div>
          <Highlighter
            highlightClassName="highlighted-text"
            searchWords={[search]}
            textToHighlight={name}
            className="overflow-ellipsis cell-active"
            autoEscape
          />
          {description && (
            <span className="description t-14">
              <Highlighter
                highlightClassName="highlighted-text"
                searchWords={[search]}
                textToHighlight={description}
                autoEscape
              />
            </span>
          )}
        </div>
      );
    }
  },
  {
    Header: () => <FormattedMessage id="surveyTable.lastPosition" defaultMessage="Last position used" />,
    accessor: 'lastPosition',
    width: 150,
    Cell: ({ cell: { value } }) => (value
      ? (
        <TextOverflowTooltip content={value} width={160}>
          <Highlighter
            highlightClassName="highlighted-text"
            searchWords={[search]}
            textToHighlight={value}
            className="cell-active"
            autoEscape
          />
        </TextOverflowTooltip>
      )
      : <EmptyFieldPlaceholder />
    )
  },
  {
    Header: () => <FormattedMessage id="surveyTable.createdBy" defaultMessage="Created by" />,
    id: 'createdBy',
    width: 110,
    Cell: ({ row }) => {
      const original = row.original as ISurvey;
      return (
        <div className="table-center" style={{ maxWidth: 75 }}>
          {getOwnerIcon(original)}
        </div>
      );
    }
  }
];
